<template>
	<v-app>
		<NavBar />
		<v-main class="ma-4">
			<v-alert
				v-if="imported"
				type="success"
				title="Successfully imported"
			></v-alert>
			<h1>CSV-Upload</h1>
			<v-file-input
				@change="handleFile($event)"
				label="CSV File"
				name="massimport"
			></v-file-input>
			<v-btn
				:disabled="file == null"
				color="primary"
				class="ma-1"
				@click="upload()"
				>Upload</v-btn
			>
			<v-btn
				:disabled="flights == 0"
				color="primary"
				class="ma-1"
				@click="submit()"
				>Submit</v-btn
			>
			<v-table v-if="flights != 0" density="compact">
				<thead>
					<tr>
						<th>Flights Total</th>
						<th>Flights error</th>
						<th>Flights valid</th>
						<th>Total time (valid)</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							{{ flights.totalFlights }}
						</td>
						<td>
							{{ flights.errorflights }}
						</td>
						<td>
							{{ flights.validflights }}
						</td>
						<td>
							{{
								formatMs(moment.duration(flights.totalTime).as("milliseconds"))
							}}
						</td>
					</tr>
				</tbody>
			</v-table>
			<v-table v-if="flights != 0" density="compact"
				><thead>
					<tr>
						<th>Date</th>
						<th>Plane</th>
						<th>Departure</th>
						<th>Arrival</th>
						<th>Off-Block</th>
						<th>On-Block</th>
						<th>Takeoffs</th>
						<th>Landings</th>
						<th>PIC</th>
						<th>Total</th>
						<th>Error</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="flight in flights.flights"
						:class="flight.approved == true ? 'bg-green' : ''"
					>
						<td>{{ moment(flight.date).format("DD.MM.YYYY") }}</td>
						<td>{{ flight.plane }}</td>
						<td>{{ flight.from }}</td>
						<td>{{ flight.to }}</td>
						<td>{{ moment(flight.off).format("HH:mm") }}</td>
						<td>{{ moment(flight.on).format("HH:mm") }}</td>
						<td>{{ flight.tko }}</td>
						<td>{{ flight.ldg }}</td>
						<td>{{ flight.pic }}</td>
						<td>
							{{ formatMs(moment.duration(flight.total).as("milliseconds")) }}
						</td>
						<td>{{ flight.errormessage }}</td>
					</tr>
				</tbody>
			</v-table>
		</v-main>
	</v-app>
</template>

<script>
import NavBar from "@/components/NavBar";
import axios from "axios";
import { mapState } from "vuex";
import moment from "moment";
import formatMs from "@/utils/formatMs";
export default {
	components: {
		NavBar,
	},
	data: () => ({
		file: null,
		flights: 0,
		importObject: null,
		imported: false,
	}),
	computed: {
		...mapState({
			token: "token",
		}),
	},
	created() {
		this.moment = moment;
		this.formatMs = formatMs;
	},
	methods: {
		upload() {
			const data = this.file;
			axios
				.post(
					process.env.VUE_APP_BACKEND_URL + "/flight/import",
					{
						massimport: data,
					},
					{
						headers: {
							Authorization: "bearer " + this.token,
							"Content-Type": "multipart/form-data",
						},
					}
				)
				.then((response) => {
					console.log(response);
					this.flights = response.data.data;
					this.importObject = response.data._id;
				});
		},
		handleFile(event) {
			this.file = event.target.files[0];
		},
		submit() {
			axios
				.post(
					process.env.VUE_APP_BACKEND_URL + "/flight/submit",
					{
						importId: this.importObject,
					},
					{
						headers: {
							Authorization: "bearer " + this.token,
						},
					}
				)
				.then((response) => {
					this.flights = 0;
					this.imported = true;
				});
		},
	},
};
</script>

<style></style>
